import * as Scrivito from "scrivito";
import { useMobileNavigation } from "^/Context/MobileNavigationContext";
import I18n from "^/config/i18n";

function BackLink({ containerClassNames, linkClassNames }) {
  const { breadcrumb, navigationLevel, dispatch } = useMobileNavigation();
  const parentId = breadcrumb[breadcrumb.length - 2];
  if (!parentId) {
    return null;
  }
  return (
    <div className={containerClassNames}>
      <a
        className={linkClassNames}
        onClick={() => {
          dispatch({
            type: "updateCurrentPageId",
            payload: {
              pageId: parentId,
              navLevel: parseInt(navigationLevel, 10) - 1,
            },
          });
          dispatch({ type: "removeFromBreadcrumb" });
        }}
      >
        <i className="las la-angle-left float-left mt-1 pe-2" />
        {I18n.t("backLink")}
      </a>
    </div>
  );
}

export default Scrivito.connect(BackLink);
